const teamData = [
  {
    teamName: "minor6 team",
    teamEmail: "test@xava.co.nz",
    teamId: 11078,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "Qwizard Test",
    teamEmail: "test@qwizard.com",
    teamId: 853,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test",
    teamEmail: "bbbbb@asd.com",
    teamId: 12162,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "Test team",
    teamEmail: "hsbv@vvu.com",
    teamId: 11751,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "Test wanna",
    teamEmail: "",
    teamId: 10475,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "Test z2",
    teamEmail: "",
    teamId: 10477,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test1",
    teamEmail: "aryo.r.h+1@gmail.com",
    teamId: 189,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test10",
    teamEmail: "",
    teamId: 13009,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "Test100",
    teamEmail: "",
    teamId: 6907,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test11",
    teamEmail: "",
    teamId: 13010,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test12",
    teamEmail: "",
    teamId: 13011,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test13",
    teamEmail: "",
    teamId: 13012,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test14",
    teamEmail: "",
    teamId: 13013,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test15",
    teamEmail: "",
    teamId: 13014,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test2",
    teamEmail: null,
    teamId: 190,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test3",
    teamEmail: "",
    teamId: 12909,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test4",
    teamEmail: "",
    teamId: 12910,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test5",
    teamEmail: "",
    teamId: 13004,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test6",
    teamEmail: "",
    teamId: 13005,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test7",
    teamEmail: "",
    teamId: 13006,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test8",
    teamEmail: "",
    teamId: 13007,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "test9",
    teamEmail: "",
    teamId: 13008,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "Testerz",
    teamEmail: "",
    teamId: 10476,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "TESTTEST",
    teamEmail: "aaaa@asd.com",
    teamId: 49,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "The Bestest",
    teamEmail: null,
    teamId: 6858,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
  {
    teamName: "The Test Eagles",
    teamEmail: "",
    teamId: 8561,
    playerCount: 4,
    rounds: [null, null, null, null, null, null, null, null],
    breaker: {
      answer: null,
      proximity: null,
      rank: null,
    },
    puzzle: [null, null, null, null, null, null, null, null],
  },
];

export const getTeamData = (count) => {
  return teamData.slice(0, count);
};
